import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        partners_balances: {
          header: 'HEADER',
          download_report_button: 'DOWNLOAD_REPORT',
          balance_adjustment: {
            header: 'ADJUSTMENT_HEADER',
            save: 'ADJUSTMENT_SAVE',
            back: 'ADJUSTMENT_BACK',
            form: {
              affiliate: 'FORM_AFFILIATE',
              current_balance: 'FORM_CURRENT_BALANCE',
              balance_amount: 'FORM_BALANCE_AMOUNT',
              comment: 'FORM_COMMENT',
            },
            modal_window: {
              title: 'MODAL_TITLE',
              question: 'MODAL_QUESTION',
              answer_yes: 'MODAL_YES',
              answer_no: 'MODAL_NO',
            },
          },
        },
      },
    },
  }));
}
